import styled from '@emotion/styled';
import {
  FEEDBACK_BUTTON_HEIGHT,
  FEEDBACK_BUTTON_PADDING,
  HEADER_HEIGHT,
  SIDE_BAR_WIDTH,
} from '@/layouts/MainLayout/utils/constants';

export const StyledAppContainer = styled.div`
  * {
    box-sizing: border-box;
  }

  width: 100%;
  min-height: 100vh;
  position: relative;
`;

export const StyledMain = styled.main<{
  shouldRenderFromTop?: boolean;
  isDesktop: boolean;
  isFlush?: boolean;
}>`
  padding-bottom: ${({ isFlush }) =>
    isFlush ? 0 : `calc(2 * ${FEEDBACK_BUTTON_PADDING} + ${FEEDBACK_BUTTON_HEIGHT})`};
  width: ${({ isDesktop }) => (isDesktop ? `calc(100% - ${SIDE_BAR_WIDTH})` : '100%')};
  height: calc(100vh - ${HEADER_HEIGHT});
  position: relative;
  top: ${({ shouldRenderFromTop }) => (shouldRenderFromTop ? 0 : `${HEADER_HEIGHT}`)};
  left: ${({ isDesktop }) => (isDesktop ? `${SIDE_BAR_WIDTH};` : 0)};
`;
